import { ReactElement, ReactNode } from 'react';
import { AppShell as MantineAppShell } from '@mantine/core';
import clsx from 'clsx';

import styles from './appShell.module.scss';

export type AppShellProps = {
  children: ReactNode;
  navigationHeader: ReactNode;
  headerHeight?: number | string;
  navigation: ReactNode;
  navigationCollapsed: boolean;
  navigationFooter?: ReactNode;
  navigationWidthCollapsed: number;
  navigationWidthExpanded: number;
  subNavigation?: ReactElement;
};

AppShell.Header = MantineAppShell.Header;

export function AppShell({
  children,
  headerHeight,
  navigationHeader,
  navigation,
  navigationCollapsed,
  navigationFooter,
  navigationWidthCollapsed,
  navigationWidthExpanded,
  subNavigation,
}: AppShellProps) {
  return (
    <MantineAppShell
      transitionDuration={0}
      layout="alt"
      padding={0}
      classNames={{
        root: styles['root'],
        main: styles['main'],
        navbar: styles['navbar'],
      }}
      header={headerHeight ? { height: headerHeight } : undefined}
      navbar={{
        width: navigationCollapsed
          ? navigationWidthCollapsed
          : navigationWidthExpanded,
        breakpoint: '',
      }}
    >
      {subNavigation}
      <MantineAppShell.Navbar unstyled>
        <MantineAppShell.Section className={clsx(styles['navbar__header'])}>
          {navigationHeader}
        </MantineAppShell.Section>
        <MantineAppShell.Section
          grow
          className={styles['navbar__main-content']}
        >
          {navigation}
        </MantineAppShell.Section>
        {navigationFooter && (
          <MantineAppShell.Section
            className={clsx(styles['navbar__footer'])}
            data-testid="navigation-footer"
          >
            {navigationFooter}
          </MantineAppShell.Section>
        )}
      </MantineAppShell.Navbar>
      <MantineAppShell.Main>{children}</MantineAppShell.Main>
    </MantineAppShell>
  );
}
